<template>
    <div id="thirdform">
        <div class="form-group">
            <p class="text-center font-weight-bolder">What are you looking to do with Followup CRM ?</p>
        </div>

        <div class="form-group">
            <b-form-group  v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                    id="checkbox-group-1"
                    v-model="form.selected_options"
                    :options="options"
                    :aria-describedby="ariaDescribedby"
                    name="flavour-1"
                    class="text-black text-md custom-calendar-checkbox"
                    @change="removeError()"
                ></b-form-checkbox-group>
            </b-form-group>
        </div>
        <p class="text-danger text-sm pl-3" v-show="hasError">Select what you are looking to do on Followup CRM</p>

        <div class="col-md-12 mt-5 text-center">
            <button class="mr-2 mt-3 btn-secondary py-3 px-4 text-white hover:text-white focus:outline-none"
                    style="border-radius: 10px; box-shadow: rgb(160 160 160) 1px 3px 8px 1px;" type="button" id="firstNext" @click="goToStepTwo()">Back
            </button>
            <button @click="saveThirdForm()" class="btn-primary py-3 px-4 text-white hover:text-white focus:outline-none"
                    style="border-radius: 10px; box-shadow: rgb(160 160 160) 1px 3px 8px 1px;" type="button" id="thirdtNext">Start using Followup CRM</button>
        </div>

    </div>
</template>

<script>

export default {
    name: "form-three",

    data() {
        return {
            form: {
                selected_options: []
            },
            options: [{
                text: 'One place to track projects',
                value: 'One place to track projects',
            },{
                text: 'Track and follow up on leads',
                value: 'Track and follow up on leads',
            },{
                text: 'Manage client relationships',
                value: 'Manage client relationships',
            },{
                text: 'Setup sales goals',
                value: 'Setup sales goals',
            },{
                text: 'Get sales reports and analytics',
                value: 'Get sales reports and analytics',
            },],
            hasError: false,
        }
    },
    methods:{
        saveThirdForm(){
            const self = this;
            if(this.form.selected_options.length === 0) {
                this.hasError = true;
            }else{
                let data = {
                    formNumber: 'three',
                    formData:self.form
                }
                Bus.$emit('updateFormData', data);
            }
        },
        removeError() {
            this.$nextTick(() => {
                this.hasError = false;
            })
        },
        goToStepTwo() {
            Bus.$emit('changeForm', 'two')
        }
    }
}
</script>

<style>
.button-custom-bottom {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
}
.custom-control {
    margin-top: 10px !important;
}
#thirdform .custom-calendar-checkbox .custom-checkbox {
    width: 100%;
}
</style>
